import { all, takeLatest } from 'redux-saga/effects';

import { imageActions } from '../index';
import upload from './upload';

const imageSagas = all([takeLatest(imageActions.uploadRequest, upload)]);

export default imageSagas;
